import { Box, Typography } from '@mui/material'
import React from 'react'
import { useSelector } from 'react-redux';
import '../style/common/ReportHeader.scss'
const ReportHeader = (props) => {
    const { reportitle = '', } = props
    const store = useSelector((store) => store);
    const { user } = store;
    const { userDetails } = user;
    return (
        <Box className='reportHeader'>
            <Typography>{reportitle}</Typography>
            <Typography>{userDetails.AgentName}</Typography>
        </Box>
    )
}

export default ReportHeader